<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addCoupon">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        :loading="table.loading"
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="code"
          :title="$t('COUPON_CODE')||'优惠券码'"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="discount"
          title="折扣(x%off)"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="expireAt"
          title="过期时间"
          width="180">
          <template slot-scope="text">
            <span v-if="text">{{text}}</span>
            <span v-else>长期有效</span>
          </template>
        </a-table-column>
        <!--        <a-table-column-->
        <!--          data-index="amount"-->
        <!--          title="固定折扣金额"-->
        <!--          width="180">-->
        <!--        </a-table-column>-->
        <!--        <a-table-column-->
        <!--          data-index="currencyCode"-->
        <!--          title="固定金额货币单位"-->
        <!--          width="120">-->
        <!--        </a-table-column>-->
        <a-table-column
          data-index="isActive"
          :title="$t('IS_ACTIVE') || '是否有效'"
          width="180">
          <template slot-scope="text,record">
            <a-tag type="success" color="blue" v-if="record.isActive==='YES'">是</a-tag>
            <a-tag type="danger" v-if="record.isActive==='NO'">否</a-tag>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editCoupon(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteCoupon(record.id)">{{ $t('DELETE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      title="优惠券"
      v-model="form.visible">
      <website-coupon-edit
        v-if="form.visible"
        :coupon-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </website-coupon-edit>
    </a-modal>
  </a-card>
</template>

<script>
import WebsiteCouponEdit from '@/views/website/coupon/WebsiteCouponEdit.vue';
import { _deleteCoupon, _queryAllCoupons } from '@/api/websiteCouponApi';

function searchUser() {
  this.table.pagination.page = 1;
  this.getCouponList();
}

async function getCouponList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryAllCoupons({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

function addCoupon() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editCoupon(couponId) {
  this.form.data.id = couponId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getCouponList();
}

function handleSizeChange(val) {
  this.table.query.size = val;
  this.getCouponList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getCouponList();
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getCouponList();
}

async function deleteCoupon(couponId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteCoupon(couponId);
      this.$message.success('删除成功');
      await this.getCouponList();
    },
  });
}

export default {
  name: 'WebsiteCouponList',
  components: {
    WebsiteCouponEdit
  },

  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getCouponList,
    editCoupon,
    addCoupon,
    closeForm,
    handlePageChange,
    handleSizeChange,
    searchUser,
    handleTableChange,
    deleteCoupon,
  },
  created() {
    this.getCouponList();
  },
};
</script>

<style scoped>

</style>
